export enum TandMSectionText {
  Management = "Management",
  Plan = "Plan"
}

export enum TandMSectionKeys {
  Management = "management",
  Plan = "plan"
}
